import * as React from 'react'
import Label from '../components/label'
import { css } from '@emotion/react'
import { StaticImage } from 'gatsby-plugin-image'

const Creator = () => {
  return (
    <section css={sectionStyle}>
      <div css={sectionInnerStyle}>
        <Label labelTitle={'POP-UP Archive'} />
        <p css={textStyle}>POP-UP 3Dで過去に開催したイベント一覧</p>
        <ul css={listStyle}>
          <li css={listBlockStyle}>
            <div css={listImageStyle}>
              <StaticImage src="../assets/images/event_03_sano.jpg" alt="POP-UP 3D #3 彫刻家 佐野藍 展" />
            </div>
            <div css={listContentsStyle}>
              <h3 css={listTitleStyle}>POP-UP 3D #3 彫刻家 佐野藍 展</h3>
              <div css={listTextStyle}>
                Real-Exhibition 2022年2月11日(祝)〜13日(日)
                <br />
                VR-Exhibition 2022年2月11日(祝)〜18日(金)
              </div>
            </div>
          </li>
          <li css={listBlockStyle}>
            <div css={listImageStyle}>
              <StaticImage src="../assets/images/event_02_yoshida.jpg" alt="POP-UP 3D #2 彫刻家 吉田孝弥 展" />
            </div>
            <div css={listContentsStyle}>
              <h3 css={listTitleStyle}>POP-UP 3D #2 彫刻家 吉田孝弥 展</h3>
              <div css={listTextStyle}>2021年11月26日(金)〜12月18日(土)</div>
            </div>
          </li>
          <li css={listBlockStyle}>
            <div css={listImageStyle}>
              <StaticImage src="../assets/images/event_01_hagiwara.jpg" alt="POP-UP 3D #1 彫刻家 萩原亮 展" />
            </div>
            <div css={listContentsStyle}>
              <h3 css={listTitleStyle}>POP-UP 3D #1 彫刻家 萩原亮 展</h3>
              <div css={listTextStyle}>2021年10月1日(金)〜23日(土)</div>
            </div>
          </li>
        </ul>
      </div>
    </section>
  )
}

const sectionStyle = css`
  width: 100%;
  margin-top: 120px;
  @media (max-width: 768px) {
    margin-top: 44px;
  }
`
const sectionInnerStyle = css`
  width: 1024px;
  margin: 0 auto;
  @media (max-width: 1023px) {
    width: 100%;
    padding: 0 24px;
  }
  @media (max-width: 768px) {
    width: 100%;
    padding: 0 16px;
  }
`
const textStyle = css`
  padding-top: 44px;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 1.8;
  @media (max-width: 768px) {
    padding-top: 24px;
  }
`
const listStyle = css`
  display: flex;
  padding-top: 40px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`
const listBlockStyle = css`
  width: calc((100% - 96px) / 3);
  margin-right: 48px;
  &:last-child {
    margin-right: 0;
  }
  @media (max-width: 768px) {
    width: 100%;
    margin-top: 32px;
    &:first-of-type {
      margin-top: 0;
    }
  }
`
const listImageStyle = css`
  width: 100%;
`
const listContentsStyle = css`
  padding: 16px 0;
`
const listTitleStyle = css`
  padding-top: 4px;
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.5;
`
const listTextStyle = css`
  padding-top: 8px;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 1.8;
`

export default Creator
